import { useParams } from 'react-router-dom';
import { chargesPayeePayerForm, deleteOrderLedgerRole, helpOrderLedgerEntryParties } from './services';
import { useForm } from 'react-hook-form';
import { useGetOrderParties } from 'hooks/useGetOrderParties';
import { useMutation } from 'react-query';
import { useState } from 'react';
import { ChargeFormEntry } from 'views/orders/charges/components/GeneralChargesTable/types';
import { normalizeLedgerError } from 'components/ledger-entry-editor/engine/errors';

const useSplitPayeePayers = (onSuccess:() => void, charges?: ChargeFormEntry[]) => {
  const { id: orderId } = useParams<{ id: string }>();
  const [errors, setErrors] = useState<string | null>(null);
  const methods = useForm<chargesPayeePayerForm>({
    defaultValues: {
      InvolvedParties: [],
      typeAmount: (charges && charges.length > 1) ? "Percent" : 'Amount'
    }
  });
  const { data } = useGetOrderParties({ orderId });
  const { mutate: updateLedgerEntryParties, ...updateLedgerEntryPartiesResponse } = useMutation(
    helpOrderLedgerEntryParties,
    {
      onSuccess: () => {
        updateLedgerEntryPartiesResponse.reset();
        onSuccess();
      },
      onError: (e: unknown) => {
        updateLedgerEntryPartiesResponse.reset();
        setErrors(normalizeLedgerError(e));
      },
    }
  );

  const { mutate: deleteRoles, isLoading: isDeleteRoleLoading } = useMutation(
    deleteOrderLedgerRole,
    {
      onSuccess: () => onSuccess(),
      onError: (e: unknown) => {
        setErrors(normalizeLedgerError(e));
      },
    }
  );

  const loadingSave = updateLedgerEntryPartiesResponse.isLoading || isDeleteRoleLoading;

  return {
    parties: data?.getOrder.parties || [],
    methods,
    updateLedgerEntryParties,
    loadingSave,
    errors,
    isDeleteRoleLoading,
    deleteRoles
  };
};

export default useSplitPayeePayers;
